import React, { useState, useEffect, useCallback } from 'react';
// import { DatePicker } from 'antd';
// import { maxBy } from 'lodash';
import PieChart from './pieChart'
// import moment from 'moment'
// import 'moment/locale/zh-cn';
// import locale from 'antd/es/date-picker/locale/zh_CN';

// const { RangePicker } = DatePicker
// moment.locale('zh-cn')

interface chartItemType {
  value: number,
  label: string,
}
export interface BrandInfoProps {
  list: any[],
  onDataUrl: any,
  bizIndex?: number,
  bizIndexRank?: number,
}

const colors = ['#FF827C', '#FF9893', '#FFB6B3', '#FFC5C2', '#FFDDDB', '#FFF2F1', '#FFDBF3', '#E9D0FF']

const BrandInfo = (props: BrandInfoProps) => {
  const { list, onDataUrl } = props;

  // const [list, setList] = useState([]);
  // useEffect(() => {
  //   if (requestPromise) {
  //     requestPromise.then((list) => {
  //       setList(list)
  //     })
  //   }
  // }, [requestPromise]);

  const [chartData, setChartData] = useState<chartItemType[]>([]);

  // const [dateType, setDateType] = useState('all');
  // const [date, setDate] = useState([]);

  useEffect(() => {
    // const nowTime = moment().format('YYYY-MM-DD')
    // let startTime = moment(nowTime)
    // let endTime: any = null
    // if (dateType === 'm6') {
    //   startTime = startTime.subtract(6, 'months')
    // } else if (dateType === 'y1') {
    //   startTime = startTime.subtract(1, 'years')
    // } else if (dateType === 'y3') {
    //   startTime = startTime.subtract(3, 'years')
    // } else if (dateType === 'custom') {
    //   startTime = startTime.subtract(100, 'years')
    //   if (date && date.length === 2) {
    //     startTime = date[0]
    //     endTime = date[1]
    //   }
    // }
    if (!Array.isArray(list)) {
      return
    }
    let newList = list
    // if (dateType !== 'all') {
    //   newList = list.filter((item: any) => {
    //     const publishTime = moment(item.publishTime).valueOf()
    //     if (publishTime >= startTime.valueOf()) {
    //       if (!endTime) {
    //         return true
    //       }
    //       if (publishTime <= endTime.valueOf()) {
    //         return true
    //       }
    //     }
    //   })
    // }
    // const identityMap = {}
    // const identityArray: chartItemType[] = []
    const brandCategoryMap = {}
    const chartData: chartItemType[] = []
    newList.forEach((item: any) => {
      // 品牌分类计数
      const brandCategory = item.tradeTypeL1 || '未知'
      if (!brandCategoryMap[brandCategory]) {
        const itemData: chartItemType = {
          label: brandCategory,
          value: 0
        }
        brandCategoryMap[brandCategory] = itemData
        chartData.push(itemData)
      }
      brandCategoryMap[brandCategory].value = brandCategoryMap[brandCategory].value + 1

      // 合作身份计数
      // const identity = item.identity
      // if (!identityMap[identity]) {
      //   const itemData: chartItemType = {
      //     label: identity,
      //     value: 0
      //   }
      //   identityMap[identity] = itemData
      //   identityArray.push(itemData)
      // }
      // identityMap[identity].value = identityMap[identity].value + 1
    })
    // setTotal(newList.length)
    // const maxData = maxBy(chartData, 'value')

    // const identityMaxData = maxBy(identityArray, 'value')

    setChartData(chartData)
  }, [list])

  return (
    <PieChart
      onDataUrl={onDataUrl}
      className="business-chart"
      data={chartData}
      unitText=""
      // guideHtml={({ total }) => {
      //   return `<div class="piechart-guide">
      //     <div class="piechart-guide-title">代言数</div>
      //     <div class="piechart-guide-text">${total}</div>
      //   </div>`
      // }}
      colors={colors}
    />
  );
};

export default React.memo(BrandInfo);

